import React from 'react'
import { Button, Typography } from '@mui/material'
import { ETH_TOKEN_ADDRESS } from '../services/amm'
import { numFormat } from '../blockchainUtils/math'
import BigNumber from 'bignumber.js'
import { getToken } from '../model/tokens/helper'
import { useWalletContext } from './WalletContext'

function Balance(props: {
    token: string
    setMaxAmountHandler: any
    amount: string | undefined
    showMaxButton: boolean
    isSelectDisabled: boolean
    setIsMaxBalance?: (isMax: boolean) => void
}) {
    const { isSelectDisabled = false, setIsMaxBalance } = props
    const { networkName: network } = useWalletContext()

    let token = props.token
    let isEthToken = token === ETH_TOKEN_ADDRESS
    let setMaxAmountHandler = props.setMaxAmountHandler
    let walletAmount = props.amount

    let showMaxButton = props.showMaxButton && Number(walletAmount) > 0
    let maxAmount = new BigNumber(walletAmount || '0')
    if (isEthToken && Number(walletAmount) >= 0.0006) maxAmount = maxAmount.minus(BigNumber(0.0006))
    if (isEthToken && Number(walletAmount) <= 0.0006) maxAmount = new BigNumber(0)
    const isHidden = walletAmount === undefined || walletAmount === ''
    if (maxAmount.gt(new BigNumber(walletAmount || '0'))) maxAmount = new BigNumber(walletAmount || '0')

    return (
        <div className={`w-full ${isHidden ? 'invisible' : ''}`}>
            <div className={`${isSelectDisabled ? 'text-white' : 'text-white'} flex items-center`}>
                <span className='text-[14px]'>Balance: {numFormat(walletAmount ? walletAmount?.toString() : '') || 0}</span>

                {showMaxButton && (
                    <Button
                        size='small'
                        sx={{ minWidth: 0, ml: 0.05, mt: -0.05 }}
                        onClick={() => {
                            const tokenObj = getToken(network!, token)
                            if (!tokenObj) return
                            setMaxAmountHandler(token, maxAmount.toFixed(tokenObj?.decimals))
                            setIsMaxBalance ? setIsMaxBalance(true) : {}
                        }}>
                        <Typography color='white' className='bg-[#0C3F6D] px-2 rounded-full' fontSize={13}>
                            max
                        </Typography>
                    </Button>
                )}
            </div>
        </div>
    )
}

export default Balance
